import notificationsActionTypes from '../actionTypes/notificationsActionTypes';

const initialStore = {
  notificationsList: [],
  notificationsPagination: {},
  unreadNotificationsList: [],
  notificationsIsLoading: false,
};

const setNotificationRead = (state, notificationId) => {
  const newState = { ...state };
  newState.unreadNotificationsList = newState.unreadNotificationsList.filter(
    (item) => item.id !== notificationId,
  );
  // eslint-disable-next-line array-callback-return
  newState.notificationsList.map((item) => {
    if (item.id === notificationId) {
      // eslint-disable-next-line no-param-reassign
      item.read = true;
    }
  });
  return newState;
};

const setAllNotificationsRead = (state) => {
  const newState = { ...state };
  newState.unreadNotificationsList = [];
  // eslint-disable-next-line array-callback-return
  newState.notificationsList.map((item) => {
    // eslint-disable-next-line no-param-reassign
    item.read = true;
  });
  return newState;
};

const reducer = (state = initialStore, { type, payload }) => {
  switch (type) {
    case notificationsActionTypes.GET_NOTIFICATIONS_START:
      return {
        ...state,
        notificationsIsLoading: true,
      };
    case notificationsActionTypes.GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationsList: payload.data,
        notificationsPagination:
          payload.meta && payload.meta.pagination ? payload.meta.pagination : {},
        notificationsIsLoading: false,
      };
    case notificationsActionTypes.GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notificationsIsLoading: false,
      };
    case notificationsActionTypes.GET_UNREAD_NOTIFICATIONS_START:
      return {
        ...state,
        notificationsIsLoading: true,
      };
    case notificationsActionTypes.GET_UNREAD_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unreadNotificationsList: payload.data,
        notificationsIsLoading: false,
      };
    case notificationsActionTypes.GET_UNREAD_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notificationsIsLoading: false,
      };
    case notificationsActionTypes.ADD_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unreadNotificationsList: [payload, ...state.unreadNotificationsList],
      };
    case notificationsActionTypes.READ_NOTIFICATION_SUCCESS:
      return setNotificationRead(state, payload);
    case notificationsActionTypes.READ_ALL_NOTIFICATIONS_SUCCESS:
      return setAllNotificationsRead(state);
    default:
      return state;
  }
};

export default reducer;
